import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useCallback, useState, useEffect } from 'react';

var useInputRef = function useInputRef(active) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      refNode = _useState2[0],
      setRefNode = _useState2[1];

  var ref = useCallback(function (node) {
    if (node !== null) setRefNode(node);
  }, []);
  useEffect(function () {
    if (!active) return;
    setTimeout(function () {
      refNode && refNode.focus();
    });
  }, [active, refNode]);
  return [ref, refNode];
};

export default useInputRef;